<template>
  <pt-report-unscramble-apply-list class="pt-report-unscramble-apply-list__withData"></pt-report-unscramble-apply-list>
</template>

<script>
import PtReportUnscrambleApplyList from './index'
export default {
  name: 'pt-report-unscramble-apply-list__withData',
  components: {
    'pt-report-unscramble-apply-list': PtReportUnscrambleApplyList
  }
}
</script>
